import { createFileRoute } from '@tanstack/react-router';
import { Typography } from '@volvo/vcdk-react';
import { useTranslation } from 'react-i18next';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import { useCanonical } from '@/hooks/useCanonical';
import FaqSection from '@/routes/_public/faq/_components/FaqSection';
import SectionCard from '@/routes/_public/faq/_components/SectionCard';
import { dealerLocatorLink } from '@/utils/baseLinks';

export const Route = createFileRoute('/_public/faq/')({
  component: SupportPageWrapper,
  errorComponent: ErrorBoundary,
});

function SupportPageWrapper() {
  useCanonical('/connect/faq');

  return (
    <div className="mt-15">
      <SupportPage />
    </div>
  );
}

export function SupportPage() {
  const { t } = useTranslation();

  return (
    <div className="mx-auto flex w-full max-w-xl flex-col gap-6">
      <div className="flex flex-col gap-4">
        <Typography variant="heading3">{t(($) => $.pages.support.title)}</Typography>
        <Typography variant="body">{t(($) => $.pages.support.description)}</Typography>
      </div>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        <SectionCard
          imageSrc="images/faq_card_1.png"
          tag={t(($) => $.pages.support.professional_support.tag)}
          title={t(($) => $.pages.support.professional_support.title)}
          description={t(($) => $.pages.support.professional_support.description)}
          linkText="Dealer locator"
          linkHref={dealerLocatorLink}
        />
        <SectionCard
          imageSrc="images/faq_card_2.png"
          tag={t(($) => $.pages.support.emergency_support.tag)}
          title={t(($) => $.pages.support.emergency_support.title)}
          description={t(($) => $.pages.support.emergency_support.description)}
          linkText="Volvo Penta Action Service"
          linkHref="https://www.volvopenta.com/your-engine/volvo-penta-action-service/"
        />
        <SectionCard
          imageSrc="images/faq_card_3.png"
          tag={t(($) => $.pages.support.platform_support.tag)}
          title={t(($) => $.pages.support.platform_support.title)}
          description={t(($) => $.pages.support.platform_support.description)}
          linkText="Contact Volvo Penta Connect Support"
          linkHref="mailto:support.volvopentaconnect@volvo.com"
        />
      </div>
      <div className="flex flex-col gap-6">
        {/* Gettings started */}
        <FaqSection title={t(($) => $.pages.support.getting_started.title)} section="getting_started" questions={10} />
        {/*  Connectivity & Telematics*/}
        <FaqSection
          title={t(($) => $.pages.support.connectivity_telematics.title)}
          section="connectivity_telematics"
          questions={7}
        />
        {/*  Campaigns & software updates*/}
        <FaqSection
          title={t(($) => $.pages.support.campaigns_software_updates.title)}
          section="campaigns_software_updates"
          questions={8}
        />
        {/*  Maintenance & service*/}
        <FaqSection
          title={t(($) => $.pages.support.maintenance_service.title)}
          section="maintenance_service"
          questions={2}
        />
        {/*  Warranty & coverage*/}
        <FaqSection
          title={t(($) => $.pages.support.warranty_coverage.title)}
          section="warranty_coverage"
          questions={5}
        />
        {/*  Notifications */}
        <FaqSection title={t(($) => $.pages.support.notification.title)} section="notification" questions={1} />
      </div>
    </div>
  );
}
